import React from "react";
import "./PlansScreen.css";
import { useEffect } from "react";
import { useState } from "react";
import db from "../firebase";
import {
  onSnapshot,
  addDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";

const PlansScreen = () => {
  const [products, setProducts] = useState([]);
  const user = useSelector(selectUser);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const getSubscriptions = async () => {
      const subscriptionsQuery = query(
        collection(db, "customers", user.uid, "subscriptions")
      );
      const querySnapshot = await getDocs(subscriptionsQuery);
      querySnapshot.forEach(async (subscriptionDoc) => {
        setSubscription({
          role: subscriptionDoc.data().role,
          current_period_end: subscriptionDoc.data().current_period_end.seconds,
          current_period_start:
            subscriptionDoc.data().current_period_start.seconds,
        });
      });
    };
    getSubscriptions();
  }, [user.uid]);

  useEffect(() => {
    const fetchDocs = async () => {
      const productsColRef = collection(db, "products");
      const productsQuery = query(productsColRef, where("active", "==", true));
      const productsArray = [];
      const querySnapshot = await getDocs(productsQuery);
      querySnapshot.forEach(async (productDoc) => {
        productsArray[productDoc.id] = productDoc.data();
        const priceSnapShot = await getDocs(
          query(collection(productDoc.ref, "prices"))
        );
        priceSnapShot.docs.forEach((price) => {
          productsArray[productDoc.id].prices = {
            priceId: price.id,
            priceData: price.data(),
          };
        });

        setProducts(productsArray);
      });
    };
    fetchDocs();
  }, []);

  const loadCheckout = async (priceId) => {
    console.log(user.uid);
    const colRef = collection(db, "customers", user.uid, "checkout_sessions");
    await addDoc(colRef, {
      price: priceId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
    })
      .then((res) => {
        console.log(res);
        console.log("Successfuly Added the data");
        onSnapshot(res, async (a) => {
          const { error, sessionId } = a.data();
          if (error) {
            alert(`An error Occured: ${error.smessage}`);
          }
          if (sessionId) {
            const stripe = await loadStripe(
              process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
            );
            console.log(`session id: ${sessionId}`);
            stripe.redirectToCheckout({ sessionId: sessionId });
          }
        });
        return res;
      })
      .catch((err) => {
        console.log(`error: ${err.message}`);
        return err;
      });
  };

  return (
    <div className="plansScreen">
      <br />
      {subscription && (
        <p>
          Renewal Date:{" "}
          {new Date(
            subscription?.current_period_end * 1000
          ).toLocaleDateString()}
        </p>
      )}
      {Object.entries(products).map(([productId, productData]) => {
        console.log(`Subscription name: ${subscription.role}`);
        console.log(`Product Name: ${productData.name}`);
        const isCurrentPlan = productData.name
          ?.toLowerCase()
          .includes(subscription.role?.toLowerCase());
        console.log(`isCurrentPlan: ${isCurrentPlan}`);
        return (
          <div key={productId} className="plansScreen__plan">
            <div className="plansScreen__info">
              <h5>{productData.name}</h5>
              <h6>{productData.description}</h6>
            </div>
            <button
              disabled={isCurrentPlan}
              onClick={async () => {
                !isCurrentPlan && loadCheckout(productData.prices.priceId);
              }}
            >
              {isCurrentPlan ? "Current Plan" : "Subscribe"}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default PlansScreen;
